import { useT } from "@/hooks/useT";
import { Alert, AlertTitle, Button, Stack, Typography } from "@mui/material";
import React from "react";

export const BlockerAlert = ({ blocker }: any) => {
  const { t } = useT();
  if (blocker.state === "blocked") {
    scrollTo({ top: 0, behavior: "smooth" });
  }
  return blocker.state === "blocked" ? (
    <Alert
      severity="warning"
      sx={{
        my: 2,
      }}
    >
      <AlertTitle>
        <Typography variant="h2">
          {t("generic.message.unsavedChanges")}
        </Typography>
        <Typography variant="h2">{t("generic.message.sureToLeave")}</Typography>
      </AlertTitle>
      <Stack direction="row" spacing={2}>
        <Button variant="outlined" onClick={() => blocker.reset()}>
          {t("generic.button.cancel")}
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => blocker.proceed()}
        >
          {t("generic.button.leavePage")}
        </Button>
      </Stack>
    </Alert>
  ) : null;
};
